import { Modal } from 'react-bootstrap';

/**
 * DK : Modal z pytaniem tak/nie
 * @param show Czy ma się wyświetlać 
 * @param onHide Funkcja wywołana gdy użytkownik odpowie na pytanie
 */
const YesNoMessageModal = ({ show, onHide, title, message, showCloseButton = true }) => {
    return (
        <>
            <Modal size='lg' show={show} onHide={onHide} centered>
                <Modal.Header closeButton={showCloseButton}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{ fontSize: '1.3rem' }}>{message}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn-app-primary me-3' onClick={() => onHide(true)}>TAK</button>
                    <button className='btn-app-secondary' onClick={() => onHide(false)}>NIE</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default YesNoMessageModal